module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area03_img_en@2x.0aaea9b6.png";